import { useMemo, useState } from "react";
import { Send, ArrowLeft } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useData } from "@/context/DataContext";
import { openWa } from "@/lib/wa";

export default function DispatchComposer({ services = [], neighborhoods = [] }) {
  const { t, pick } = useLang();
  const { zones } = useData();
  const [service, setService] = useState("");
  const [hood, setHood] = useState("");
  const [car, setCar] = useState("");

  const hoodName = useMemo(() => {
    const h = neighborhoods.find((n) => n.slug === hood);
    return h ? pick(h.name_ar, h.name_en) : "";
  }, [hood, neighborhoods, pick]);

  const serviceName = useMemo(() => {
    const s = services.find((sv) => sv.slug === service);
    return s ? pick(s.title_ar, s.title_en) : "";
  }, [service, services, pick]);

  const send = () => {
    const msg = `السلام عليكم، أرغب في طلب خدمة من ميرو للإطارات وخدمات السيارات.\nالخدمة المطلوبة: ${serviceName || "____"}.\nالحي: ${hoodName || "____"} بالرياض.\nنوع السيارة: ${car || "____"}.\nأرجو توضيح التوفر والتكلفة.`;
    openWa(msg);
  };

  const selectCls = "field appearance-none cursor-pointer";

  return (
    <div className="card-glass p-6 sm:p-10" data-testid="dispatch-composer">
      <div className="grid gap-5 md:grid-cols-3">
        <div>
          <label className="mb-2 block text-sm font-bold text-gold">{t("home.composerService")}</label>
          <select value={service} onChange={(e) => setService(e.target.value)} className={selectCls} data-testid="composer-service-select">
            <option value="">—</option>
            {services.map((s) => <option key={s.slug} value={s.slug}>{pick(s.title_ar, s.title_en)}</option>)}
          </select>
        </div>
        <div>
          <label className="mb-2 block text-sm font-bold text-gold">{t("home.composerArea")}</label>
          <select value={hood} onChange={(e) => setHood(e.target.value)} className={selectCls} data-testid="composer-hood-select">
            <option value="">—</option>
            {zones.map((z) => (
              <optgroup key={z.id} label={pick(z.ar, z.en)}>
                {neighborhoods.filter((n) => n.zone === z.id).map((n) => (
                  <option key={n.slug} value={n.slug}>{pick(n.name_ar, n.name_en)}</option>
                ))}
              </optgroup>
            ))}
          </select>
        </div>
        <div>
          <label className="mb-2 block text-sm font-bold text-gold">{t("home.composerCar")}</label>
          <input value={car} onChange={(e) => setCar(e.target.value)} placeholder={t("home.composerCarPh")} className="field" data-testid="composer-car-input" />
        </div>
      </div>
      <div className="mt-6 flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs leading-6 text-dim">{t("home.composerHint")}</p>
        <button onClick={send} data-testid="composer-send-button" className="btn-gold shrink-0">
          <Send size={17} /> {t("home.composerSend")}
        </button>
      </div>
    </div>
  );
}
